module.exports = __webpack_public_path__ + "img/swimmers-2.0782f10a.jpg";